import { Outlet } from 'react-router-dom';
import { PageRoutes } from './paths';
import Login from '../pages/auth/Login/Login';
import VerifyOTP from '../pages/auth/VerifyLogin/VerifyOTP';
import ForgotPassword from '../pages/auth/ForgotPassword/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword/ResetPassword';
import ResetPasswordVerifyOTP from '../pages/auth/VerifyLogin/ResetPasswordVerifyOTP';
import Dashboard from '../pages/unAuth/Dashboard/Dashboard';
import ProAccounts from '../pages/unAuth/ProAccounts/ProAccounts';
import AccountSettings from '../pages/unAuth/AccountSettings/AccountSettings';
import ListIcons from '../pages/unAuth/ListIcons/ListIcons';
import ReferralTracking from '../pages/unAuth/ReferralTracking/ReferralTracking';
import Campaigns from '../pages/unAuth/Campaigns/Campaigns';
import FishinityProCenter from '../pages/unAuth/FishinityProCenter/FishinityProCenter';
import SponseredUsers from '../pages/unAuth/SponseredUsers/SponseredUsers';
import { ASSESTS } from '../constant/assest';
import Portfolios from '../pages/unAuth/ProAccounts/children/Portfolios/Portfolios';
import { RouteObject } from "react-router-dom";
import WaterbodiesCampaign from '../pages/unAuth/Campaigns/children/WaterbodiesCampaign/WaterbodiesCampaign';
import Reengagement from '../pages/unAuth/Campaigns/children/Reengagement/Reengagement';
import Newsletters from '../pages/unAuth/Campaigns/children/Newsletters/Newsletters';
import UserSettings from '../pages/unAuth/AccountSettings/children/UserSettings/UserSettings';
import OtpGuard from './OtpGuard';
import NotFound from '../pages/unAuth/PageNotFound/PageNotFound';

export default interface IRouteConfig {
  displayName?: string;
  routeProps: RouteObject;
  showInNavMenu?: boolean;
  navMenuIcon?: string;
  icon?: string;
  children?: IRouteConfig[];
}


const AUTH_ROUTES: IRouteConfig[] = [
    {
        displayName: 'Login',
        routeProps: {
            path: PageRoutes.LOGIN,
            element: <Login />,
        },
    },
    {
        displayName: 'OTP Verify',
        routeProps: {
            path: PageRoutes.OTPVERIFY,
            element: (
            <OtpGuard isLoginPending={!!localStorage.getItem("isLoginPending")}>
                <VerifyOTP />
            </OtpGuard>)
        },
    },
    {
        displayName: 'Forgot Password',
        routeProps: {
            path: PageRoutes.FORGOTPASSWORD,
            element: <ForgotPassword />,
        },
    },
    {
        displayName: 'Reset Password',
        routeProps: {
            path: PageRoutes.RESETPASSWORD,
            element: <ResetPassword />,
        },
    },
    {
        displayName: 'Reset Password Verify OTP',
        routeProps: {
            path: PageRoutes.RESETPASSWORDOTPVERIFY,
            element: <ResetPasswordVerifyOTP />,
        },
    },
];

const UNAUTH_ROUTES: IRouteConfig[] = [
    {
        displayName: 'Dashboard',
        routeProps: {
            path: PageRoutes.DASHBOARD,
            element: <Dashboard />,
        },
        showInNavMenu: true,
        icon: ASSESTS.DASHBOARD,
    },
    {
        displayName: 'Newsletters',
        routeProps: {
            path: PageRoutes.NEWSLETTER,
            element: <Newsletters />,
        },
        showInNavMenu: true,
        icon: ASSESTS.NEWSLETTERS,
    },
    {
        displayName: 'Pro Accounts',
        routeProps: {
            path: PageRoutes.PROACCOUNTS,
            element: <Outlet />,
        },
        icon: ASSESTS.PROACCOUNT,
        showInNavMenu: true,
        children:[
            {
                displayName: 'Pro Accounts',
                routeProps: {
                    // index: true,
                    path: PageRoutes.PROACCOUNTS,
                    element: <ProAccounts />,
                },
                showInNavMenu: false,
            },
            {
                displayName: 'Portfolios',
                routeProps: {
                    path: `${PageRoutes.PORTFOLIOS}/:userId?`,
                    element: <Portfolios />,
                },
                showInNavMenu: true,
            },
        ]
    },
    {
        displayName: 'List Icons',
        routeProps: {
            path: PageRoutes.LISTICONS,
            element: <ListIcons />,
        },
        showInNavMenu: true,
        icon: ASSESTS.LISTICONS,
    },
    {
        displayName: 'Referral Tracking',
        routeProps: {
            path: PageRoutes.REFERALTRACKING,
            element: <ReferralTracking />,
        },
        showInNavMenu: true,
        icon: ASSESTS.REFERRALTRACKING,
    },
    {
        displayName: 'Campaigns',
        routeProps: {
            path: PageRoutes.COMPAIGNS,
            element: <Outlet />,
        },
        showInNavMenu: true,
        icon: ASSESTS.COMPAIGNS,
        children:[
            {
                displayName: 'Parent',
                routeProps: {
                    // index: true,
                    path: PageRoutes.COMPAIGNS,
                    element: <Campaigns />,
                },
                showInNavMenu: false,
            },
            {
                displayName: 'Anglers Engagement',
                routeProps: {
                    path: PageRoutes.ANGLERSENGAGEMENT,
                    element: <Campaigns />,
                },
                showInNavMenu: true,
            },
            {
                displayName: 'Waterbodies campaign',
                routeProps: {
                    // path: PageRoutes.WATERBODIESCOMPAIGN,
                    element: <WaterbodiesCampaign />,
                },
                showInNavMenu: true,
            },
            {
                displayName: 'Reengagement',
                routeProps: {
                    // path: PageRoutes.REENGAGEMENT,
                    element: <Reengagement />,
                },
                showInNavMenu: true,
            },
            {
                displayName: 'Newsletters',
                routeProps: {
                    // path: PageRoutes.NEWSLETTERS,
                    element: <Newsletters />,
                },
                showInNavMenu: true,
            },
        ]
    },
    {
        displayName: 'Fishinity Pro Center',
        routeProps: {
            // path: PageRoutes.FISHINITYPROCENTER,
            element: <FishinityProCenter />,
        },
        showInNavMenu: true,
        icon: ASSESTS.FISHINITYPROCENTER,
    },
    {
        displayName: 'Account Settings',
        routeProps: {
            path: PageRoutes.ACCOUNTSETTINGS,
            element: <Outlet />,
        },
        showInNavMenu: true,
        icon: ASSESTS.ACCOUNTSETTINGS,
        children:[
            {
                displayName: 'Account Settings',
                routeProps: {
                    // index: true,
                    path: PageRoutes.ACCOUNTSETTINGS,
                    element: <AccountSettings />,
                },
                showInNavMenu: false,
            },
            {
                displayName: 'User Settings',
                routeProps: {
                    // path: PageRoutes.USERSETTINGS,
                    element: <UserSettings />,
                },
                showInNavMenu: true,
            },
        ]
    },
    {
        displayName: 'Sponsered Users',
        routeProps: {
            // path: PageRoutes.SPONSORESUSERS,
            element: <SponseredUsers />,
        },
        showInNavMenu: true,
        icon: ASSESTS.SPONSORESUSERS,
    },
    {
        displayName: 'Not Found',
        routeProps: {
            path: PageRoutes.PAGENOTFOUND,
            element: <NotFound />,
        },
        showInNavMenu: false,
    },
];

export { AUTH_ROUTES, UNAUTH_ROUTES };